var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inlineGalleryCard"},[_c('img',{ref:"img",staticClass:"inlineImage",class:{
      'isZoomed' : _vm.zoomed,
      'isHigh' : _vm.isHigh,
      },style:(_vm.tinyImg),attrs:{"src":_vm.path},on:{"click":function($event){return _vm.toggleZoom()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }